import React, { useContext, useEffect, useState } from "react";
import { HelmetProvider } from 'react-helmet-async';
import { ProductContext } from "../context/AppContext";
import axios from "axios";

interface SchoolAutomation {
  schoolName?: string;
  schoolLogo?: string;
}

const SetSchoolTitle: React.FC = () => {
  const [Automationdata, setAutomationdata] = useState<SchoolAutomation | null>(
    null
  );

  const fetchSchoolAutomationData = async () => {
    try {
      const response = await axios.get(
        "https://api.mirai.healthcare/api/head/school-rule/school-automation",
        {
          headers: {
            accept: "application/json",
          },
        }
      );
      if (response?.data) {
        setAutomationdata(response?.data?.[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchSchoolAutomationData();
  }, []);

  const schoolName = Automationdata?.schoolName;
  const schoolLogo = Automationdata?.schoolLogo;

  useEffect(() => {
    if (schoolLogo) {
      // Change favicon dynamically
      const link =
        document.querySelector("link[rel~='icon']") ||
        document.createElement("link");
      link.setAttribute("rel", "icon");
      link.setAttribute("href", schoolLogo);
      document.head.appendChild(link);
    }
  }, [schoolLogo]);

  return (
    <HelmetProvider>
      <title>{schoolName}</title>
    </HelmetProvider>
  );
};

export default SetSchoolTitle;
